import { Icon } from "./Icon.tsx";

/** A diamond (NetworkMap.tsx's divider marker shape) with a plus badge, same "shape + plus" convention as AddJunctionIcon. */
export function AddDividerIcon() {
  return (
    <Icon>
      <path d="M10 4l6 6-6 6-6-6z" />
      <path d="M18 3v6M15 6h6" />
    </Icon>
  );
}
